import { API } from "../constants/api";
import {
  axiosPostWithToken,
  axiosGetWithToken,
  axiosPut,
} from "../services/apiServices";
import { ERROR_ALERT, SUCCESS_ALERT } from "./commonAction";
import { getDateFilter } from "@flexibees/core";

export const GET_RECRUITMENT = "GET_RECRUITMENT";
export const RECRUITMENT_LOADING = "RECRUITMENT_LOADING";
export const SET_RECRUITMENT_ITEMS_PER_PAGE = "SET_RECRUITMENT_ITEMS_PER_PAGE";
export const CHANGE_CURRENT_RECRUITMENT_PAGE =
  "CHANGE_CURRENT_RECRUITMENT_PAGE";
export const SEARCH_RECRUITMENT = "SEARCH_RECRUITMENT";
export const FILTER_RECRUITMENT_FUNCTIONS = "FILTER_RECRUITMENT_FUNCTIONS";
export const FILTER_RECRUITMENT_ROLES = "FILTER_RECRUITMENT_ROLES";
export const PULL_DATA_GET_RECRUITMENT = "PULL_DATA_GET_RECRUITMENT";
export const FILTER_RECRUITMENT_STATUS = "FILTER_RECRUITMENT_STATUS";
export const FILTER_RECRUITMENT_RECRUITER = "FILTER_RECRUITMENT_RECRUITER";
export const FILTER_RECRUITMENT_BDMANAGER = "FILTER_RECRUITMENT_BDMANAGER";
export const FILTER_RECRUITMENT_DATE = "FILTER_RECRUITMENT_DATE";
export const SET_RECRUITMENT_PRICING_HISTORY =
  "SET_RECRUITMENT_PRICING_HISTORY";
export const VIEW_REOPEN_REASON = "VIEW_REOPEN_REASON";
export const VIEW_RECRUITMENT_PROJECT_INFO = "VIEW_RECRUITMENT_PROJECT_INFO";
export const FILTER_RECRUITMENT_NO_OF_DAYS = "FILTER_RECRUITMENT_NO_OF_DAYS";

export const getRecruitment = () => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    const pagesize = getstate().recruit.recruitmentResultsPerPage;
    const page = getstate().recruit.recruitmentCurrentPage;
    const seachText = getstate().recruit.recruitmentSearchText;
    const functions = getstate().recruit.recruitmentAppliedFunctionFilter;
    const roles = getstate().recruit.recruitmentAppliedRolesFilter;
    const status = getstate().recruit.recruitmentAppliedStatusFilter;
    const recruiters = getstate().recruit.recruitmentAppliedRecruiterFilter;
    const bdManager = getstate().recruit.recruitmentAppliedBDManagerFilter;
    const no_of_days = getstate().recruit.recruitmentAppliedNoOfDaysFilter;
    const date = getDateFilter(
      getstate().recruit.recruitmentAppliedDateFilter[0]
    );

    const body = {
      search_term: seachText,
      filter_data: {
        functions: functions,
        roles: roles,
        status: status,
        recruiters: recruiters,
        start_date: date,
        bd_managers: bdManager,
        no_of_days: no_of_days,
      },
    };

    axiosPostWithToken(
      `${API.GET_RECRUITMENT}/${pagesize}/${page}/`,
      body,
      token
    ).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: GET_RECRUITMENT,
          payload: res.data.data,
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data.message ||
            "Something went wrong. Unable to fetch data.",
        });
      }
    });
  };
};

export const viewProjectInfo = (id, dataFetchComplete) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    axiosGetWithToken(`${API.VIEW_PROJECT_INFO}/${id}/`, token).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: VIEW_RECRUITMENT_PROJECT_INFO,
          payload: res.data.data,
        });
        dataFetchComplete();
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload: "Something went wrong.",
        });
        dataFetchComplete();
      }
    });
  };
};

export const viewReOpenReason = (project_id, toggleModal, whichModal) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;

    axiosGetWithToken(`${API.VIEW_REOPEN_REASON}/${project_id}/`, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: VIEW_REOPEN_REASON,
            payload: res.data.data,
          });
          toggleModal(whichModal);
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload:
              res.data.data.message ||
              "Something went wrong. Unable to fetch data.",
          });
        }
      }
    );
  };
};

export const fetchPricingHistory = (projectId, toggleModal, whichModal) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosGetWithToken(
      `${API.GET_RECRUITMENT_PRICING_HISTORY}/${projectId}/`,
      token
    ).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: SET_RECRUITMENT_PRICING_HISTORY,
          payload: res.data.data.pricing,
        });
        toggleModal(whichModal);
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data.message ||
            "Something went wrong. Unable to fetch pricing details.",
        });
      }
    });
  };
};

export const startRecruitment = (project_id, refresh) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;

    axiosPut(`${API.START_RECRUITMENT}/${project_id}/`, {}, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: res.data.data.message,
          });
          refresh(project_id);
        } else if (res?.data?.status_code === 400) {
          dispatch({
            type: ERROR_ALERT,
            payload:
              res?.data?.data?.message ||
              "Something went wrong. Unable to process request.",
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: "Something went wrong. Unable to process request.",
          });
        }
      }
    );
  };
};

export const setItemsPerPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: RECRUITMENT_LOADING,
    });
    dispatch({
      type: SET_RECRUITMENT_ITEMS_PER_PAGE,
      payload: value,
    });
  };
};

export const changeCurrentPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: RECRUITMENT_LOADING,
    });
    dispatch({
      type: CHANGE_CURRENT_RECRUITMENT_PAGE,
      payload: value,
    });
  };
};

export const search = (value) => {
  return async (dispatch) => {
    dispatch({
      type: RECRUITMENT_LOADING,
    });
    dispatch({
      type: SEARCH_RECRUITMENT,
      payload: value,
    });
  };
};

export const filterFunctions = (functions) => {
  return async (dispatch) => {
    dispatch({
      type: RECRUITMENT_LOADING,
    });
    dispatch({
      type: FILTER_RECRUITMENT_FUNCTIONS,
      payload: functions,
    });
  };
};

export const filterRoles = (roles) => {
  return async (dispatch) => {
    dispatch({
      type: RECRUITMENT_LOADING,
    });
    dispatch({
      type: FILTER_RECRUITMENT_ROLES,
      payload: roles,
    });
  };
};

export const filterStatus = (status) => {
  return async (dispatch) => {
    dispatch({
      type: RECRUITMENT_LOADING,
    });
    dispatch({
      type: FILTER_RECRUITMENT_STATUS,
      payload: status,
    });
  };
};

export const filterRecruiter = (recruiter) => {
  return async (dispatch) => {
    dispatch({
      type: RECRUITMENT_LOADING,
    });
    dispatch({
      type: FILTER_RECRUITMENT_RECRUITER,
      payload: recruiter,
    });
  };
};

export const filterBDManager = (bdManager) => {
  return async (dispatch) => {
    dispatch({
      type: RECRUITMENT_LOADING,
    });
    dispatch({
      type: FILTER_RECRUITMENT_BDMANAGER,
      payload: bdManager,
    });
  };
};

export const filterNoOfDays = (days) => {
  return async (dispatch) => {
    dispatch({
      type: RECRUITMENT_LOADING,
    });
    dispatch({
      type: FILTER_RECRUITMENT_NO_OF_DAYS,
      payload: days,
    });
  };
};

export const filterStartDate = (date) => {
  return async (dispatch) => {
    dispatch({
      type: RECRUITMENT_LOADING,
    });
    dispatch({
      type: FILTER_RECRUITMENT_DATE,
      payload: date,
    });
  };
};
